import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Navigation from "../../components/Navigation/Navigation";
import back from "../../assets/back.png";
import { request } from "../../utils/axios-utils";
import { toast } from "react-hot-toast";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import dragIcon from "../../assets/drag.png";
import arrowIcon from "../../assets/right_arrow.png";

const CategoryOrder = () => {
  const { slug } = useParams();
  const location = useLocation();
  const pathSnippets = location.pathname.split("/").filter((i) => i);
  const currentSlug = pathSnippets[pathSnippets.length - 1];

  const [loading, setLoading] = useState("");
  const [languageList, setLanguageList] = useState([]);
  const [category, setCategory] = useState({});
  const [subCategories, setSubCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [menuCurrency, setMenuCurrency] = useState("");

  const onCategoryDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;

    if (source.index === destination.index) {
      return;
    }

    const updatedCategories = Array.from(subCategories);
    const [movedCategory] = updatedCategories.splice(source.index, 1);
    updatedCategories.splice(destination.index, 0, movedCategory);

    setSubCategories(updatedCategories);

    try {
      const response = await request({
        url: "/member/update-category-order",
        method: "POST",
        data: { updatedCategories, slug },
      });

      toast.success(response.data.message);
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  const onItemDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;

    if (source.index === destination.index) {
      return;
    }

    const updatedItems = Array.from(items);
    const [movedItem] = updatedItems.splice(source.index, 1);
    updatedItems.splice(destination.index, 0, movedItem);

    setItems(updatedItems);

    try {
      const response = await request({
        url: "/member/update-item-order",
        method: "POST",
        data: { updatedItems, slug },
      });

      toast.success(response.data.message);
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading("data");
        //LanguageList
        const response = await request({
          url: "/member/get-languages",
          method: "POST",
          data: { slug },
        });

        //Category Data
        const categoryResponse = await request({
          url: "/member/get-category-data",
          method: "POST",
          data: { slug, categoryId: currentSlug },
        });

        setLanguageList(response.data.languages);
        setCategory(categoryResponse.data.category);
        setSubCategories(categoryResponse.data.subcategories);
        setItems(categoryResponse.data.items);
        setMenuCurrency(response.data.menuCurrency);
      } catch (error) {
        toast.error(error.response.data.message);
      } finally {
        setLoading("");
      }
    };

    getData();
  }, [location.pathname]);

  return (
    <Navigation isLoading={loading === "data"}>
      <h1 className="page-content-h">
        Order:{" "}
        {category?.name &&
          languageList.length > 0 &&
          category.name[languageList[0]]}
      </h1>
      <p className="page-content-p">Manage your items and categories order.</p>

      <DragDropContext onDragEnd={onCategoryDragEnd}>
        <Droppable droppableId="categories" direction="vertical">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="languages-container"
            >
              <Link
                className="menu-editor-back-btn"
                to="#"
                onClick={() => window.history.back()}
              >
                <img className="menu-editor-back-img" src={back} />
                <p className="menu-editor-back-p">GO BACK</p>
              </Link>
              {subCategories.map((category, index) => (
                <Draggable
                  key={category.id}
                  draggableId={category.id}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <Link
                      to={`${location.pathname}/${category.id}`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`menu-order-div ${
                        snapshot.isDragging ? "dragging" : ""
                      }`}
                    >
                      <div className="menu-order-name-div">
                        <img className="menu-order-drag-img" src={dragIcon} />
                        <p className="menu-order-name">
                          {category.name[languageList[0]]}
                        </p>
                      </div>
                      <img className="menu-order-arrow-img" src={arrowIcon} />
                    </Link>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <DragDropContext onDragEnd={onItemDragEnd}>
        <Droppable droppableId="categories" direction="vertical">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="languages-container"
            >
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`menu-order-div ${
                        snapshot.isDragging ? "dragging" : ""
                      }`}
                    >
                      <div className="menu-order-name-div">
                        <img className="menu-order-drag-img" src={dragIcon} />
                        <p className="menu-order-name">
                          {item.name[languageList[0]]}
                        </p>
                      </div>

                      <div className="menu-order-name-div">
                        {item.weight && (
                          <p className="menu-order-weight">{`(${item?.weight})`}</p>
                        )}

                        <p className="menu-order-name">
                          {item.price.toFixed(2)}
                          {menuCurrency}
                        </p>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Navigation>
  );
};

export default CategoryOrder;
